module.exports = __webpack_public_path__ + "img/post-germany-cod-alternate.2a8d91ed.png";